import Favicon from './favicon.js'
export default Favicon
